module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auction-sidebar"
  }, [_c('b-nav', {
    staticClass: "w-100 h-100",
    attrs: {
      "vertical": ""
    }
  }, [_c('b-nav-item', {
    staticClass: "p-0",
    attrs: {
      "to": {
        name: 'auction'
      },
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.auctionDashboard')))]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "p-0",
    attrs: {
      "to": {
        name: 'itemList'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('item.items')))]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "p-0",
    attrs: {
      "to": {
        name: 'itemOrders'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('item.orderingCounts')))]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "p-0",
    attrs: {
      "to": {
        name: 'bidList'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.bids')))]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "p-0",
    attrs: {
      "to": {
        name: 'pendingBidList'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.pendingBids')))]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "p-0",
    attrs: {
      "to": _vm.generateUrl('sellers')
    }
  }, [_vm._v(_vm._s(_vm.$t('common.sellers')))]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "p-0",
    attrs: {
      "to": _vm.generateUrl('buyers')
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buyers')))]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "p-0",
    attrs: {
      "to": {
        name: 'auctionPhotos'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('auction.photos')))]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "p-0",
    attrs: {
      "to": {
        name: 'auctionLists'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('auction.lists')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20b7aa72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/includes/AuctionSidebar.vue
// module id = 1285
// module chunks = 1